import { isAllowedMimeType } from "../utils";

const validateAndSetFile = ({ file, setUploadedFile, setFileUploadError }) => {
  if (!(file instanceof Blob)) return;
  if (!isAllowedMimeType({ file })) {
    setFileUploadError(true);
    return;
  }
  setUploadedFile(file);
};

export const FileUploaderDomain = {
  validateAndSetFile,
};
